export const BASE_URL =
    process.env.REACT_APP_DEVELOP === 'TRUE'
        ? 'http://localhost:4001/luxtech/api'
        : process.env.REACT_APP_API_URL;

// export const BASE_URL = 'http://localhost:4001/luxtech/api';
